import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const RESET_HINT = 'Ask in #cai-notifications to reset this customer.'

interface ChangeDotButtonProps {
  locked: boolean
  sent: boolean
  onClick: () => void
}

export function ChangeDotButton({ locked, sent, onClick }: ChangeDotButtonProps) {
  if (!locked) {
    return (
      <Button type="button" variant="link" size="sm" className="h-auto px-0" onClick={onClick}>
        Change
      </Button>
    )
  }
  const reason = sent
    ? `The application was sent, so the DOT can't change here. ${RESET_HINT}`
    : `Files were already read for this DOT, so it can't change here. ${RESET_HINT}`
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0}>
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto px-0"
            disabled
            aria-disabled="true"
          >
            Change
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  )
}
